export const PAGES = [];
